import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Modal,
  ButtonToolbar,
  OverlayTrigger,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  checkPermision,
  dateDefault,
  formLabelsTheme,
  getValueType,
  iconError,
  optionsStatus,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  useForceUpdate,
} from "../../../utility";
import SVG from "react-inlinesvg";
import Select from "react-select";
import {
  sortCaret,
  headerSortingClasses,
  toAbsoluteUrl,
} from "../../../../_metronic/_helpers";
import {
  selectPagination,
  selectUser,
} from "../../../modules/Auth/_redux/authRedux";

// MUI
import {
  fade,
  withStyles,
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { red } from "@material-ui/core/colors";
// import { UserCreate } from "./UserCreate";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import {
  resetData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchReporting,
  selectReporting,
  fetchFile,
  fetchFileBlob,
  fetchRdm,
  selectManager,
} from "../reportingSlice";
import { ReportTable } from "./ReportTable";

import { useStyles, useStylesReddit } from "../../../utility";

import { ModalColorRadio } from "../../modalfilter/ModalColorRadio";
import { ModalProductRadio } from "../../modalfilter/ModalProductRadio";
import { ModalModelRadio } from "../../modalfilter/ModalModelRadio";
import { ModalClientRadio } from "../ModalClientRadio";
import {
  fetchParameter,
  fetchParameter2,
  selectParameter,
  selectParameter2,
} from "../../businessParameter/businessParameterSlice";
import { Autocomplete } from "@material-ui/lab";
import { FormHelperText } from "@material-ui/core";

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export const RDMPage = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(selectManager);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const paginationSet = useSelector(selectPagination);
  const forceUpdate = useForceUpdate();

  useEffect(() => {
    async function fetchMyAPI() {
      await resetData();

      // Fetch data on first load
      await dispatch(
        fetchRdm({
          pageNo: 1,
          pageSize: paginationSet,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  const [formValues, setFormValues] = useState({
    report_name: {
      value: "",
      error: false,
      required: "Y",
    },
    requester: {
      value: "",
      error: false,
      required: "N",
    },
    request_date_start: {
      value: "",
      error: false,
      required: "N",
    },
    request_date_end: {
      value: "",
      error: false,
      required: "N",
    },
  });

  const handleSearch = async () => {
    if (
      (formValues.request_date_start.value &&
        !formValues.request_date_end.value) ||
      (formValues.request_date_end.value &&
        !formValues.request_date_start.value)
    ) {
      return showErrorDialog(
        "Please fill in both date filters: From Date and Until Date."
      );
    }
    let params = {
      pageNo: 1,
      pageSize: paginationSet,
      report_name: formValues.report_name.value,
      requester: formValues.requester.value,
      request_date_start: formValues.request_date_start.value,
      request_date_end: formValues.request_date_end.value,
    };

    try {
      const response = await dispatch(fetchRdm(params));
      if (response.payload.data.status === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      let params = {
        pageNo: page,
        pageSize: sizePerPage,
        report_name: formValues.report_name.value,
        requester: formValues.requester.value,
        request_date_start: formValues.request_date_start.value,
        request_date_end: formValues.request_date_end.value,
      };

      try {
        const response = await dispatch(fetchRdm(params));
        if (response.payload.data.status === 200) {
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      let result;
      if (sortOrder === "asc") {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
      }
    }
  };

  const handleDownload = async () => {};
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <div>
        <Card>
          <CardBody>
            <div className="mb-5">
              <ThemeProvider theme={formLabelsTheme}>
                <Row>
                  <Col xs={12} sm={3} md={5} lg={5}>
                    <RedditTextField
                      label="Report Name"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      type="text"
                      size="small"
                      name="report_name"
                      fullWidth
                      onChange={handleChange}
                      value={formValues.report_name.value}
                    />
                    <RedditTextField
                      label="Requester"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      type="text"
                      size="small"
                      name="requester"
                      fullWidth
                      onChange={handleChange}
                      value={formValues.requester.value}
                    />
                  </Col>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <Row>
                      <Col xs={12} sm={3} md={5} lg={5}>
                        <RedditTextField
                          label="Date Requested From"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          type="date"
                          size="small"
                          name="request_date_start"
                          fullWidth
                          onChange={handleChange}
                          value={formValues.request_date_start.value}
                        />
                      </Col>
                      <Col xs={1} sm={1} md={1} lg={1}>
                        <p className="text-center mt-5">To</p>
                      </Col>
                      <Col xs={12} sm={3} md={5} lg={5}>
                        <RedditTextField
                          label="Date Requested To"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          type="date"
                          size="small"
                          name="request_date_end"
                          fullWidth
                          onChange={handleChange}
                          value={formValues.request_date_end.value}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </ThemeProvider>
            </div>

            <Row className="mt-6 justify-content-end">
              <Button
                className="mr-3 btn-filter"
                variant="primary"
                onClick={handleSearch}
              >
                Search
              </Button>
            </Row>

            <ReportTable
              data={data === null ? [] : data}
              page={pageNo}
              sizePerPage={pageSize}
              totalSize={totalRecord}
              onTableChange={handleTableChange}
              loading={loading}
              handleSearch={handleSearch}
            />
          </CardBody>
        </Card>
      </div>
    </>
  );
};
